import React from 'react';
import PropTypes from 'prop-types';

function SvgEyeHide({ fill, ...props }) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 512.001 383.985" {...props}>
      <g data-name="Group 91">
        <g data-name="Group 90">
          <path
            data-name="Path 1160"
            d="M316.332 131.654a10.665 10.665 0 10-15.083 15.083 63.993 63.993 0 11-90.5 90.5 10.665 10.665 0 10-15.083 15.083 85.324 85.324 0 10120.666-120.666z"
            fill={fill}
          />
        </g>
      </g>
      <g data-name="Group 93">
        <g data-name="Group 92">
          <path
            data-name="Path 1161"
            d="M270.87 108.123a84.482 84.482 0 00-100.2 83.861 83.512 83.512 0 001.493 14.869 10.68 10.68 0 0010.475 8.811 9.453 9.453 0 001.877-.171 10.679 10.679 0 008.64-12.352A61.848 61.848 0 01192 191.984a63.231 63.231 0 0175.157-62.869 10.659 10.659 0 003.712-20.992z"
            fill={fill}
          />
        </g>
      </g>
      <g data-name="Group 95">
        <g data-name="Group 94">
          <path
            data-name="Path 1162"
            d="M509.462 185.092c-2.411-2.859-60.117-70.208-139.712-111.445a10.672 10.672 0 10-9.792 18.966C421.27 124.359 470.251 173.892 487 191.986c-25.429 27.541-125.5 128-231 128-35.8 0-71.872-8.64-107.264-25.707a10.658 10.658 0 00-9.258 19.2c38.293 18.5 77.5 27.84 116.523 27.84 131.435 0 248.555-136.619 253.483-142.443a10.658 10.658 0 00-.022-13.784z"
            fill={fill}
          />
        </g>
      </g>
      <g data-name="Group 97">
        <g data-name="Group 96">
          <path
            data-name="Path 1163"
            d="M326 54.939c-24.277-8.171-47.829-12.288-69.995-12.288-131.439 0-248.559 136.619-253.487 142.441a10.666 10.666 0 00-.6 12.992c1.472 2.112 36.736 52.181 97.856 92.779a10.592 10.592 0 0014.763-3.008 10.636 10.636 0 00-2.987-14.763c-44.885-29.845-75.605-65.877-87.1-80.533C49 165.892 149.74 63.985 256 63.985c19.861 0 41.131 3.755 63.189 11.157a10.521 10.521 0 0013.5-6.7A10.647 10.647 0 00326 54.939z"
            fill={fill}
          />
        </g>
      </g>
      <g data-name="Group 99">
        <g data-name="Group 98">
          <path
            data-name="Path 1164"
            d="M444.865 3.12a10.674 10.674 0 00-15.083 0L67.116 365.792A10.665 10.665 0 0082.2 380.87L444.865 18.203a10.674 10.674 0 000-15.083z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

SvgEyeHide.propTypes = {
  fill: PropTypes.string,
};

SvgEyeHide.defaultProps = {
  fill: '#fff',
};

export default SvgEyeHide;
